import _assertClassBrand from "./assertClassBrand.js";
//#region \0@oxc-project+runtime@0.151.0/helpers/esm/classPrivateFieldGet2.js
function _classPrivateFieldGet2(s, a) {
	return s.get(_assertClassBrand(s, a));
}
//#endregion
export { _classPrivateFieldGet2 as default };
